/* eslint-disable react/prop-types */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function StepsImage(props) {
  const { step } = props;
  const data = useStaticQuery(graphql`
    query {
      step1: file(relativePath: { eq: "step1.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      step2: file(relativePath: { eq: "step2.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      step2A: file(relativePath: { eq: "step2A.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      step2B: file(relativePath: { eq: "step2B.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      step3: file(relativePath: { eq: "step1.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      step4: file(relativePath: { eq: "step4.png" }) {
        childImageSharp {
          fluid(pngQuality: 100, maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return <Img fluid={data[step].childImageSharp.fluid} {...props} />;
}
